import { useMutation } from 'react-query'

import { APIError } from '../../../../../../../../../../../../../utils'
import { createContactPayment, CreateContactPaymentPayload } from '../query-api'

interface UseCreateContactPaymentProps {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export const useCreateContactPayment = (props?: UseCreateContactPaymentProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: create,
    isLoading: isProcessing,
    ...rest
  } = useMutation((payload: CreateContactPaymentPayload) => createContactPayment(payload), {
    onError,
    onSuccess,
  })

  return { create, isProcessing, ...rest }
}
